<template>
    <!-- A sign-off's signature, and for a role sheet seat sign-off the seat as it read when it was signed -->
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <div v-if="signOff.SignatureData">
                <img :src="signOff.SignatureData" />
            </div>
            <div style="font-size: 18px;margin:25px 0 0;font-weight:bold">{{ signOff.Signature }}</div>
            <div v-if="signOff.Seat" class="rv rv-signed">
                <div class="rv-sn">{{ seatLabel(signOff.Seat) || 'Seat' }}</div>
                <role-seat :accountabilities="signOff.Seat.accountabilities" :sections="signOff.Seat.sections" prefix="signed" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import RoleSeat from '@/components/RoleSeat.vue';
import { seatLabel } from '@/roleSheet';

export default defineComponent({
    name: 'SignOffCells',
    components: { RoleSeat },
    // signOff.Seat: the seat snapshot (readSeatSignOff in roleSheet.ts), set by the sign-off lists
    props: [ 'signOff' ],
    emits: [ 'close' ],
    methods: {
        seatLabel
    }
})
</script>
